module.exports = __webpack_public_path__ + "static/img/PG.256f8ced.png";